




































































































































import { Component, Vue, Prop } from 'vue-property-decorator';

import { EnumObject, TireStoringInfo, TireTypeEnum } from '@/models';
import { imageService } from '@/services';

import CarouselTireImage from '../CarouselTireImage.vue';

@Component({
  components: {
    CarouselTireImage
  },
})
export default class TireInfoCard extends Vue {
  @Prop() public tire!: TireStoringInfo;
  private showScratchImage: boolean = true;
  private isWinterTire: boolean = false;
  private urlScratchImage = "";
  private tireConditionOptions: EnumObject[] = [
    { value: 0, text: 'enum.tire_condition.blank' },
    { value: 1, text: 'enum.tire_condition.yes' },
    { value: 2, text: 'enum.tire_condition.no' },
  ];
  private tireHardnessOptions: EnumObject[] = [
    { value: 0, text: 'enum.tire_hardness.blank' },
    { value: 1, text: 'enum.tire_hardness.good' },
    { value: 2, text: 'enum.tire_hardness.caution' },
    { value: 3, text: 'enum.tire_hardness.exchange_required' },
  ];

  private created() {
    if (this.tire) {
      this.loadImageUrl(this.tire);
      if (this.tire.type === TireTypeEnum.WINTER) {    
        this.isWinterTire = true;
      }
    }
  }

  private getTireConditionText(value: number): string {
    const item = this.tireConditionOptions.find((option) => option.value === value);
    return (item && item.text) ? item.text : '';
  }

  private getTireHardnessText(value: number): string {
    const item = this.tireHardnessOptions.find((option) => option.value === value);
    return (item && item.text) ? item.text : '';
  }

  private getTireHardnessClass(value: number): string {
    if (value === 1) {
      return 'hardness-label-good';
    } else if (value === 2) {
      return 'hardness-label-caution';
    } else if (value === 3) {
      return 'hardness-label-required-exchange';
    } else {
      return '';
    }
  }

  private loadImageUrl(tire: TireStoringInfo) {
    const templateUrl = require('@/assets/img/tire_scratch.png');
    tire.imageUrl = tire.imageId ? imageService.getImageUrl(tire.imageId) : ""; 
    
    if(tire.imageScratch.length > 0){
      tire.imageScratch.forEach(tireImage => {
        if (tireImage.id) {
          tire.imageScratchUrl.push(imageService.getImageUrl(tireImage.id!));
          let setImage = [...new Set(tire.imageScratchUrl)];
          tire.imageScratchUrl = setImage;
        }
      })
    } else {
      this.urlScratchImage = templateUrl;
    }
    
  }

}
